// Generated with SMAASearchImageData.generate().toCanvas().toDataURL(), not cropped, low dynamic range.
export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAhCAAAAABIXyLAAAAAOElEQVRIx2NgGAWjYBSMglEwEICREYRgFBZBqDCSLA2MGPUIVQETE9iNUAqLR5gIeoQKRgwXjwAAGn4AtaFeYLEAAAAASUVORK5CYII";



// WEBPACK FOOTER //
// ./src/lib/vendor/postprocessing/materials/images/smaa/searchImageDataURL.js